<template>
  <resource-list-wrapper :title="$t('resources.page_tests.title')">
    <template #default>
      <va-list
        ref="list"
        :resource="resourceName"
        :filter.sync="customFiltersValues"
        :filters="filters"
        :labels-list="labelsList"
        disable-export
        disable-create
        disableBulkDelete
        :domains-list="domainsList"
        :create-button-label="$t('generic.buttons.create')">
        <template #no-data>
          <div class="no-results">
            {{ $t("custom.no_data") }}
          </div>
        </template>
        <template #no-results>
          <div class="no-results">
            {{ $t("custom.no_data") }}
          </div>
        </template>
        <template #[`filter.search`]="props">
          <v-text-field
            class="search-filter"
            hide-details
            v-bind="props"
            label=""
            :placeholder="$t('generic.search_label')"
            @input="val => updateFiltersValues('q', val)">
          </v-text-field>
        </template>
        <va-data-table
          :fields="fields"
          class="va-table--selectable test-table"
          disable-select
          actionsColWidth="84px"
          showExpand
          :singleExpand="false"
          showExpandAll>
          <template #[`field.page.slug`]="{ item }">
            <div @click="editResource('pages', item.page.id)" class="slug-field">{{ item.page.slug }}</div>
          </template>
          <template #[`field.page.status`]="{ item }">
            <v-chip :color="findStatusName(item.page.status).chipColor">{{
              findStatusName(item.page.status).text
            }}</v-chip>
          </template>
          <template #[`field.page.label.name`]="{ item }">
            <v-tooltip top v-if="item.page.additionalLabels.length > 0 && item.page.label">
              <template #activator="{ on }">
                <div v-on="on" class="labels-wrapper">
                  <v-chip :color="getLabelChipColor(item.page.label)" :style="{ color: item.page.label.color }">
                    {{ item.page.label.name }}
                  </v-chip>
                  {{ `+${item.page.additionalLabels.length}` }}
                </div>
              </template>
              {{ getAdditionalLabels(item.page) }}
            </v-tooltip>
            <v-chip
              v-else-if="item.page.label"
              :color="getLabelChipColor(item.page.label)"
              :style="{ color: item.page.label.color }">
              {{ item.page.label.name }}
            </v-chip>
            <v-tooltip top v-else-if="item.page.additionalLabels.length > 1 && !item.page.label">
              <template #activator="{ on }">
                <div v-on="on" class="labels-wrapper">
                  <v-chip
                    :color="getLabelChipColor(item.page.additionalLabels[0])"
                    :style="{ color: item.page.additionalLabels[0].color }">
                    {{ item.page.additionalLabels[0].name }}
                  </v-chip>
                  {{ `+${item.page.additionalLabels.length - 1}` }}
                </div>
              </template>
              {{ getAdditionalLabels(item.page, true) }}
            </v-tooltip>
            <v-chip
              v-else-if="item.page.additionalLabels.length === 1"
              :color="getLabelChipColor(item.page.additionalLabels[0])"
              :style="{ color: item.page.additionalLabels[0].color }">
              {{ item.page.additionalLabels[0].name }}
            </v-chip>
          </template>
          <template #[`field.page.updatedAt`]="{ item }">
            {{ changeDateFormat(item.page.updatedAt, isUserUS($store.state.user.timezone)) }}
          </template>
          <template #[`cell.actions`]="{ item }">
            <v-tooltip v-if="item.page.status === 2" top>
              <template #activator="{ on }">
                <v-btn icon color="accent" @click.stop="visitLivePage(item.page.domain, item.page.slug)" v-on="on">
                  <span class="v-btn__content">
                    <v-icon style="width: 18px"> {{ icons.mdiOpenInNew }}</v-icon>
                  </span>
                </v-btn>
              </template>
              <span>{{ $t("resources.pages.visit_page") }} </span>
            </v-tooltip>
            <v-tooltip v-if="item.page.status === 1 || item.page.status === 3" top>
              <template #activator="{ on }">
                <v-btn icon color="info" @click.stop="preview(item.page.slug, item.page.domain.id)" v-on="on">
                  <span class="v-btn__content">
                    <v-icon style="width: 18px">{{ icons.mdiEye }} </v-icon>
                  </span>
                </v-btn>
              </template>
              <span>{{ $t("resources.pages.preview") }} </span>
            </v-tooltip>
            <DataListActions
              :actions="[
                {
                  title: 'Edit',
                  icon: 'mdi-pencil-outline',
                  function: editResource.bind(this, 'pages', item.page.id),
                },
                {
                  title: 'Preview',
                  icon: 'mdi-eye',
                  function: preview.bind(this, item.page.slug, item.page.domain.id, null),
                },
                {
                  title: 'Visit page',
                  icon: 'mdi-open-in-new',
                  function: visitLivePage.bind(this, item.page.domain, item.page.slug),
                },
              ]">
            </DataListActions>
          </template>
          <template v-slot:expanded-item="{ item }">
            <td colspan="7" class="nested-table-cell" v-if="getNumberArray(item).length > 0">
              <table class="nested-table">
                <thead>
                  <tr>
                    <th style="width: 40px"></th>
                    <th style="width: 30%">
                      {{ $t("resources.page_tests.fields.phone_number") }}
                    </th>
                    <th style="width: 70%">
                      {{ $t("resources.page_tests.fields.ringba_tag") }}
                    </th>
                    <th style="width: 154px"></th>
                    <th style="width: 154px"></th>
                    <th style="width: 100px"></th>
                    <th style="width: 84px"></th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(obj, index) in getNumberArray(item)" :key="obj.number + index">
                    <td></td>
                    <td>
                      {{ obj.number }}
                    </td>
                    <td>
                      <div v-if="obj.code && obj.type === 'script'">
                        {{ `b-js.ringba.com/${obj.code}` }}
                      </div>
                      <div v-else-if="obj.code && obj.type === 'worker'">
                        {{ obj.code }}
                      </div>
                      <div class="no-code" v-else>{{ $t("resources.page_tests.no_code") }}</div>
                    </td>
                    <td>
                      <v-chip v-if="obj.type === 'script'" color="element-bg-200" class="script-chip">{{
                        $t("resources.page_tests.script")
                      }}</v-chip>
                      <v-chip v-else-if="obj.type === 'worker'" color="element-bg-100" class="wrapper-chip">{{
                        $t("resources.page_tests.wrapper")
                      }}</v-chip>
                    </td>
                    <td>
                      <a
                        :href="`https://app.ringba.com/#/dashboard/campaign/${obj.code}`"
                        target="_blank"
                        v-if="obj.code && obj.type === 'script'"
                        class="ringba-link">
                        <v-icon>mdi-open-in-new</v-icon>
                        {{ $t("resources.page_tests.open_ringba") }}
                      </a>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td colspan="7" class="nested-table-cell" v-else-if="getCurrentError(item)">
              <div class="no-data">{{ $t("resources.page_tests.error_occurred") }} {{ getCurrentError(item) }}</div>
            </td>
            <td colspan="7" class="nested-table-cell" v-else>
              <div class="no-data">{{ $t("resources.page_tests.no_data") }}</div>
            </td>
          </template>
        </va-data-table>
      </va-list>
    </template>
  </resource-list-wrapper>
</template>

<script>
  import { changeDateFormat } from "@/@core/utils/filter";
  import { isUserUS } from "@/utility/isUserUS";
  import ResourceListWrapper from "@/components/resourceWrappers/ResourceListWrapper";
  import DataListActions from "@/components/custom/DataListActions";
  import debounce from "lodash.debounce";
  import definedAbility from "@/ability";
  import Preview from "@/mixins/previewMethod";
  import { PAGE_STATUSES } from "../../constant/index";
  import ConnectedDomainsList from "@/mixins/connectedDomainsList";
  import { mdiOpenInNew, mdiEye } from "@mdi/js";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    components: {
      ResourceListWrapper,
      DataListActions,
    },
    mixins: [Preview, ConnectedDomainsList],
    props: {
      resourceName: {
        type: String,
        default() {
          return this.$route.meta.resource;
        },
      },
      activeFilterOnload: {
        type: Object,
        default: () => ({}),
      },
      /**
       * True if component is used in VA-admin generated route for resource list;
       * False when used elsewhere (Single domain view for example).
       */
      listPage: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        ability: definedAbility(),
        changeDateFormat,
        isUserUS,
        labelsList: [],
        customFiltersValues: this.activeFilterOnload,
        filters: [
          {
            source: "search",
            alwaysOn: true,
          },
          {
            source: "page.domain",
            label: "domain",
            type: "select",
            attributes: {
              reference: "domains",
              itemText: "name",
            },
          },
          {
            source: "number",
            label: "ringba",
          },
          {
            source: "page.status",
            label: "status",
          },
          {
            source: "label",
          },
          {
            source: "success",
          },
        ],
        fields: [
          {
            source: "page.domain.name",
            label: this.$t("resources.page_tests.fields.domain"),
            sortable: true,
            width: "30%",
          },
          {
            source: "page.slug",
            sortable: true,
            label: this.$t("resources.page_tests.fields.slug"),
            width: "70%",
          },
          {
            source: "page.status",
            sortable: true,
            label: this.$t("resources.page_tests.fields.status"),
            width: "154px",
          },
          {
            source: "page.label.name",
            label: this.$t("resources.page_tests.fields.label"),
            sortable: true,
            cellClass: "label-cell",
            width: "154px",
          },
          {
            source: "page.updatedAt",
            label: this.$t("resources.page_tests.fields.updated_at"),
            sortable: true,
            width: "100px",
          },
        ],
        icons: {
          mdiOpenInNew,
          mdiEye,
        },
      };
    },
    async mounted() {
      this.$refs.list.listState.options.sortBy = ["page.updatedAt"];
      this.$refs.list.listState.options.sortDesc = [true];

      try {
        const { data } = await this.$admin.dataProvider.getList("labels", { disablePagination: true });
        this.labelsList = data;
      } catch (e) {
        this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
      }
    },
    methods: {
      getCurrentError(item) {
        return item.context?.error?.error;
      },
      getNumberArray(item) {
        if (item.context.error || !item.context.data) {
          return [];
        }

        return item.context.data;
      },
      getAdditionalLabels(item, removeFirst = false) {
        if (removeFirst) {
          return item.additionalLabels
            .slice(1)
            .map(label => label.name)
            .join(", ");
        }

        return item.additionalLabels.map(label => label.name).join(", ");
      },
      getLabelChipColor(item) {
        let hex = item.color;
        let r = parseInt(hex.slice(1, 3), 16);
        let g = parseInt(hex.slice(3, 5), 16);
        let b = parseInt(hex.slice(5, 7), 16);

        return "rgba(" + r + ", " + g + ", " + b + ", " + 0.12 + ")";
      },
      async visitLivePage(domain, slug) {
        const id = domain.id;
        let { data } = await this.$admin.dataProvider.getOne("domains", {
          id,
        });

        if (slug === "/") {
          window.open(`https://${data.url}/`, "_blank");
        } else {
          window.open(`https://${data.url}/${slug}/`, "_blank");
        }
      },
      editResource(resource, resourceId) {
        this.$router.push({ name: `${resource}_edit`, params: { id: resourceId } });
      },
      findStatusName(statusValue) {
        return PAGE_STATUSES.find(status => status.value === statusValue);
      },
      updateFiltersValues: debounce(function (source, value) {
        this.customFiltersValues = {
          ...this.customFiltersValues,
          [source]: value,
        };
      }, 400),
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .labels-wrapper {
    @include text-caption();
    color: get-color("body");
    display: flex;
    align-items: center;
    gap: 2px;
  }

  ::v-deep {
    .label-cell {
      padding: 12px 0 12px 8px !important;
    }
  }

  .test-table {
    ::v-deep {
      .v-data-table {
        td,
        th {
          padding: 0px 4px;
        }

        th .v-input--checkbox {
          padding: 0 4px;
        }

        .v-data-table__checkbox {
          padding: 0 4px;
        }

        .data-list--action-btn {
          min-width: unset !important;
        }

        .item-actions {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
        }

        .v-btn--icon {
          width: unset !important;
        }
        .expand-all-button {
          i {
            color: get-color("icon");

            &.expanded {
              background: get-color("primary-20");
              color: get-color("primary");
              border-radius: 50%;
            }
          }
        }

        .v-data-table__expand-icon {
          svg {
            fill: get-color("icon");
          }
        }
      }
    }

    .slug-field {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .nested-table-cell {
    padding: 0 !important;

    .no-data {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: get-color("element-bg-200") !important;
    }
  }

  .nested-table {
    min-width: unset;
    border: none !important;
    border-spacing: 0;
    width: 100%;

    thead {
      th {
        background-color: get-color("element-bg-200") !important;
        border-bottom: 1px solid get-color("border") !important;
        padding: 10px 4px !important;
        font-weight: 700;
        line-height: 16px;
        font-size: 12px;
        color: get-color("subtitle");
        text-align: left;
        text-transform: uppercase;
      }
    }

    tbody {
      background-color: get-color("element-bg-200") !important;

      td {
        padding: 6px 4px !important;
      }

      tr:not(:last-child) > td {
        border-bottom: 1px solid get-color("border") !important;
      }

      .no-code {
        width: 76%;
        color: get-color("subtitle");
        font-size: 14px;
      }

      .script-chip {
        border: 1px solid get-color("border") !important;

        ::v-deep {
          span {
            color: get-color("subtitle") !important;
          }
        }
      }

      .ringba-link {
        color: get-color("primary");
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 4px;
        text-decoration: none;

        ::v-deep {
          i {
            color: get-color("primary") !important;
            font-size: 16px;
          }
        }
      }
    }
  }
</style>
